import {
  createMultiStyleConfigHelpers,
  StyleThemingProps,
} from '~/utils/chakraUtils'
import { MultiStyleType } from '~/utils/chakraUtils'
import { mergeMultiStyleConfig } from '~/utils/styleHelpers'

import { textStyleKeys } from '@mangovoice/design-system'
import { textStyles } from '@mangovoice/design-system'

import { PhoneComponentSizes } from './Constants'

const {
  Page: { padding: PagePadding },
} = PhoneComponentSizes

const callErrorParts = [
  'container',
  'header',
  'errorIcon',
  'headerText',
  'errorBody',
  'errorText',
  'micBody',
  'link',
  'body1',
  'h6',
  'disconnectedTitle',
] as const

const helpers = createMultiStyleConfigHelpers(callErrorParts)

export const CallErrorStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      flexDirection: 'column',
      alignSelf: 'center',
      alignItems: 'center',
      width: '600px',
      height: '480px',
      gap: '24px',
      paddingY: {
        base: PagePadding.sm.px,
        lg: PagePadding.md.px,
        xl: PagePadding.lg.px,
      },
    },
    header: {
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-between',
      height: '16px',
      width: '500px',
    },
    errorIcon: {
      color: 'red.emphasized',
      boxSize: '30px',
      gap: '24px',
    },
    headerText: {
      color: 'red.emphasized',
      ...textStyles[textStyleKeys.Body1_Bold],
    },
    errorBody: {
      flexDirection: 'column',
      alignItems: 'center',
      gap: '24px',
    },
    errorText: {
      color: 'fg.default',
      textAlign: 'center',
    },
    micBody: {
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
    link: {
      color: 'mango.blue',
    },
    body1: {
      ...textStyles[textStyleKeys.Body1],
    },
    h6: {
      ...textStyles[textStyleKeys.H6],
    },
    disconnectedTitle: {
      color: 'fg.default',
      ...textStyles[textStyleKeys.Body1_Bold],
    },
  },
  defaultProps: {},
})

export const useCallErrorStyle = (props?: StyleThemingProps) => {
  return mergeMultiStyleConfig(CallErrorStyle, props) as MultiStyleType<
    typeof callErrorParts
  >
}
